import Vue from "vue";
import Vuex from "vuex";
import storePublisherPlugin from "./plugins";
import state from "./state";
import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";
import actionsBdc from "./bdc/actions-bdc";
import stateBdc from "./bdc/state-bdc";
import mutationsBdc from "./bdc/mutations-bdc";
import gettersBdc from "./bdc/getters-bdc";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [storePublisherPlugin],
  state: {
    ...state,
    bdc: stateBdc
  },
  mutations: {
    ...mutations,
    ...mutationsBdc
  },
  actions: {
    ...actions,
    ...actionsBdc
  },
  getters: {
    ...getters,
    ...gettersBdc
  }
});
